// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.0
//   protoc               unknown
// source: qonto/registration/register/partner_registrations/firstparty/v1/get_partner_registration.proto

/* oxlint-disable */
import { ApiPartnerRegistration } from "./partner_registration";

/** Request message for retrieving a partner registration */
export interface ApiGetPartnerRegistrationRequest {
  /** ID of the partner registration resource */
  readonly id: string;
}

/** Response message for retrieving a partner registration */
export interface ApiGetPartnerRegistrationResponse {
  /** The partner registration resource */
  readonly partnerRegistration: ApiPartnerRegistration | null;
}

export const ApiGetPartnerRegistrationRequest: MessageFns<ApiGetPartnerRegistrationRequest> = {
  fromJSON(object: any): ApiGetPartnerRegistrationRequest {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: ApiGetPartnerRegistrationRequest): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    return obj;
  },
};

export const ApiGetPartnerRegistrationResponse: MessageFns<ApiGetPartnerRegistrationResponse> = {
  fromJSON(object: any): ApiGetPartnerRegistrationResponse {
    return {
      partnerRegistration: isSet(object.partnerRegistration)
        ? ApiPartnerRegistration.fromJSON(object.partnerRegistration)
        : isSet(object.partner_registration)
        ? ApiPartnerRegistration.fromJSON(object.partner_registration)
        : null,
    };
  },

  toJSON(message: ApiGetPartnerRegistrationResponse): unknown {
    const obj: any = {};
    if (message.partnerRegistration !== undefined && message.partnerRegistration !== null) {
      obj.partnerRegistration = ApiPartnerRegistration.toJSON(message.partnerRegistration);
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
